import AuthRoutes from './route-types.js'
import { hasValidAuthToken } from '@/services/authToken'
import { resolveAppUrl } from './returnUrl'

/**
 * Already signed in - send them into the app instead of showing a login form. Full navigation
 * so App.vue bootstraps against the existing session; aborting the navigation by assigning
 * window.location without calling next() matches the idiom in router/index.js.
 */
function redirectIfSignedIn(to, from, next) {
  if (hasValidAuthToken()) {
    window.location.assign(resolveAppUrl(to.query.returnUrl))
    return
  }
  next()
}

const SignInView = () => import('./SignIn.vue')
const SignInCsrView = () => import('./SignInCsr.vue')
const ForgotPasswordView = () => import('./ForgotPassword.vue')
const ForgotPasswordCsrView = () => import('./ForgotPasswordCsr.vue')
const ResetPasswordView = () => import('./ResetPassword.vue')
const ForgotPasswordLogListView = () => import('./ForgotPasswordLogListView.vue')

const menuCode = 'A200'

export default [
  {
    path: AuthRoutes.SignInView.path,
    name: AuthRoutes.SignInView.name,
    component: SignInView,
    beforeEnter: redirectIfSignedIn,
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.SignInCsrView.path,
    name: AuthRoutes.SignInCsrView.name,
    component: SignInCsrView,
    beforeEnter: redirectIfSignedIn,
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.ForgotPasswordView.path,
    name: AuthRoutes.ForgotPasswordView.name,
    component: ForgotPasswordView,
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.ForgotPasswordCsrView.path,
    name: AuthRoutes.ForgotPasswordCsrView.name,
    component: ForgotPasswordCsrView,
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.ResetPasswordView.path,
    name: AuthRoutes.ResetPasswordView.name,
    component: ResetPasswordView,
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.ForgotPasswordLogListView.path,
    name: AuthRoutes.ForgotPasswordLogListView.name,
    component: ForgotPasswordLogListView,
    meta: {
      id: menuCode,
      route: 'listing',
      title: 'Forgot Password Log',
      name: 'Forgot Password Log'
    }
  }
]